/**
 * Canonical ticker → sector lookup used to derive a sector breakdown from
 * raw live holdings. In this static v0 replica the four ported funds carry
 * explicit `sectors` arrays (holdings are empty without the live feed), so
 * the derived path is never exercised — the map is intentionally empty.
 * Populate when wiring live holdings.
 */
export const CONSTITUENT_SECTORS: Record<string, string> = {};
